// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PX2H","clinicsSelect":"styles_clinicsSelect__3jLX0"};